export default {
    title: 'Статус',
    placeholder: '-',
};
